(function () {
    'use strict';
    angular.module("EventListApp").directive('accordion', function () {
        return {
            // attribute
            restrict: 'A',
            scope: {
                // default: '400ms'
                // options: 'milliseconds', 'slow', or 'fast'
                toggleSpeed: '@toggleSpeed',
                slideUpSpeed: '@slideUpSpeed',
                // default: 'swing'
                // options: 'swing', 'linear'
                toggleEasing: '@toggleEasing',
                slideUpEasing: '@slideUpEasing',
                isOpen: '@isOpen'
            },
            link: function (scope, element, attrs) {
                element.find('.accordion-toggle').click(function () {
                    var elem = $(this)
                    var ie = elem.find('i');

                    if (scope.isOpen == true) {
                        ie.removeClass('mdi-chevron-up');
                        ie.addClass('mdi-chevron-right');
                        scope.isOpen = false;
                    }
                    else {
                        ie.removeClass('mdi-chevron-right');
                        ie.addClass('mdi-chevron-up');
                        scope.isOpen = true;
                    }
                    elem = elem.next();
                    //elem.setAttribute('class', scope.isOpen ? 'myClassOpen' : 'myClassClose');
                    elem.slideToggle(scope.toggleSpeed, scope.toggleEasing);
                    $(".accordion-content").not($(this).next()).slideUp(scope.slideUpSpeed, scope.slideUpEasing);
                });
            }
        };
    });
})();